import { AdminModule } from '@app/modules/admin';
import { useIntl } from 'react-intl';
import { Page } from '../../../../../components/page/Page';
import { AlertIcon } from '../AlertIcon';
import { ManageAlertsWaGroup } from './ManageAlertsWaGroup';

export const ManageAlertsPage = () => {
  const { $t } = useIntl();

  const title = $t({
    id: 'admin.groups.alertsScreen.title',
    defaultMessage: 'Alertas',
  });

  return (
    <Page data-cy="admin-alerts-screen" htmlTitle={title}>
      <Page.Header
        icon={<AlertIcon />}
        title={title}
        breadcrumbs={<Page.ModuleBreadcrumbs module={AdminModule} />}
      />
      <Page.Content>
        <ManageAlertsWaGroup />
      </Page.Content>
    </Page>
  );
};
